import React from 'react';
import { Card, Col, Divider, List, Row, Typography } from 'antd';
import Layout from '../components/layout/Layout';

const { Title, Paragraph, Text } = Typography;

export default function Home() {
  const methods = [
    'AHP (Analytic Hierarchy Process)',
    'BWM (Best-Worst Method)',
  ];

  return (
    <Layout>
      <div style={{ padding: '34px 0 10px' }}>
        <Title level={1} style={{ marginBottom: 14 }}>
          PSI Pairwise Comparison Tool
        </Title>

        <Paragraph style={{ marginBottom: 30, maxWidth: 980 }}>
          This application provides a unified workspace for pairwise comparison and preference elicitation.
          It integrates AHP and BWM workflows so users can define criteria, complete comparisons,
          compute weights, and evaluate consistency in a consistent and transparent process.
        </Paragraph>

        <Row gutter={[20, 20]} style={{ marginBottom: 14 }}>
          <Col xs={24} lg={10}>
            <Card
              title="Platform Scope"
              styles={{ header: { fontWeight: 600 } }}
              style={{ borderColor: '#dbe3ec' }}
            >
              <List
                dataSource={[
                  'Pairwise weighting workflows for MCDA studies',
                  'Consistency diagnostics (CI/CR and related indicators)',
                  'Spreadsheet import/export for reproducible analysis',
                ]}
                renderItem={(item) => (
                  <List.Item style={{ border: 'none', padding: '4px 0' }}>
                    {item}
                  </List.Item>
                )}
              />
            </Card>
          </Col>

          <Col xs={24} lg={14}>
            <Card
              title="Integrated Methods"
              styles={{ header: { fontWeight: 600 } }}
              style={{ borderColor: '#dbe3ec' }}
            >
              <List
                dataSource={methods}
                renderItem={(item) => (
                  <List.Item style={{ border: 'none', padding: '4px 0' }}>
                    {item}
                  </List.Item>
                )}
              />
            </Card>
          </Col>
        </Row>

        <Text style={{ display: 'block', marginBottom: 18 }}>
          For additional method integration requests, contact Dr. River Huang at{' '}
          <a href="mailto:river.huang@psi.ch">river.huang@psi.ch</a>.
        </Text>

        <Divider />

        <Title level={3} style={{ marginBottom: 12 }}>
          Reference
        </Title>
        {/* <Paragraph style={{ marginBottom: 8 }}>
          Huang, H., Burgherr, P. (2024). <em>MCDA Calculator: A Streamlined Decision Support System for Multi-criteria Decision Analysis.</em>{' '}
          <a href="https://doi.org/10.1007/978-3-031-59376-5_3" target="_blank" rel="noreferrer">
            DOI: 10.1007/978-3-031-59376-5_3
          </a>
        </Paragraph> */}
        <Paragraph style={{ marginBottom: 8 }}>
          Related platform:{' '}
          <a href="https://mcda-calculator.psi.ch/" target="_blank" rel="noreferrer">
            MCDA Calculator
          </a>
        </Paragraph>
      </div>
    </Layout>
  );
}
